module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a9ae5a704790cef0c3d5456c3bd4a7c9.png";